import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { 
  X, 
  ArrowLeft,
  Phone,
  Mail,
  MessageSquare
} from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-red-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        
        {/* Main Cancel Card */}
        <Card className="border-0 shadow-2xl bg-white mb-8">
          <CardHeader className="text-center pb-8 pt-12">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                <X size={32} className="text-yellow-600" />
              </div>
            </div>
            
            <CardTitle className="text-3xl font-bold text-yellow-600 mb-4">
              Pago Cancelado
            </CardTitle>
            
            <p className="text-lg text-slate-600 max-w-md mx-auto">
              Has cancelado el proceso de pago. No se realizó ningún cargo a tu tarjeta.
            </p>
          </CardHeader>
          
          <CardContent className="space-y-8 pb-12">
            {/* Information */}
            <div className="bg-yellow-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-yellow-900 mb-3">
                ¿Qué pasó?
              </h3>
              <div className="space-y-2 text-yellow-800">
                <p>• El proceso de pago fue cancelado por tu solicitud</p>
                <p>• No se procesó ningún cargo</p>
                <p>• Tu información de tarjeta está segura</p>
                <p>• Puedes intentar nuevamente cuando desees</p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                className="flex-1 bg-red-600 hover:bg-red-700 text-white py-3"
                onClick={() => window.location.href = '/#paquetes'}
              >
                <ArrowLeft size={20} className="mr-2" />
                Intentar de Nuevo
              </Button>
              
              <Button 
                variant="outline" 
                className="flex-1 border-slate-300 text-slate-700 hover:bg-slate-50 py-3"
                onClick={() => window.location.href = '/'}
              >
                Volver al Inicio
              </Button>
            </div>

            {/* Alternative Options */}
            <div className="bg-slate-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-slate-900 mb-4 text-center">
                ¿Prefieres Otro Método?
              </h3>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="text-center">
                  <Phone size={32} className="text-red-600 mx-auto mb-3" />
                  <h4 className="font-semibold text-slate-900 mb-2">Llamar</h4>
                  <p className="text-sm text-slate-600 mb-3">
                    Habla directamente con nosotros
                  </p>
                  <a 
                    href="tel:+15052260487"
                    className="text-red-600 hover:underline text-sm font-medium"
                  >
                    +1 (505) 226-0487
                  </a>
                </div>
                
                <div className="text-center">
                  <Mail size={32} className="text-red-600 mx-auto mb-3" />
                  <h4 className="font-semibold text-slate-900 mb-2">Email</h4>
                  <p className="text-sm text-slate-600 mb-3">
                    Envíanos tus preguntas
                  </p>
                  <a 
                    href="mailto:info@drywall-design.com"
                    className="text-red-600 hover:underline text-sm font-medium"
                  >
                    info@drywall-design.com
                  </a>
                </div>
                
                <div className="text-center">
                  <MessageSquare size={32} className="text-red-600 mx-auto mb-3" />
                  <h4 className="font-semibold text-slate-900 mb-2">Cotización</h4>
                  <p className="text-sm text-slate-600 mb-3">
                    Solicita una cotización personalizada
                  </p>
                  <a 
                    href="/#solicitar"
                    className="text-red-600 hover:underline text-sm font-medium"
                  >
                    Ir al Formulario
                  </a>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Additional Information */}
        <Card className="border-0 shadow-lg bg-white">
          <CardContent className="p-6">
            <div className="text-center">
              <h3 className="font-semibold text-slate-900 mb-3">
                Razones Comunes para Cancelar Pagos:
              </h3>
              <div className="grid md:grid-cols-2 gap-4 text-sm text-slate-600">
                <div className="space-y-2">
                  <p>• Necesitas más información sobre el servicio</p>
                  <p>• Quieres cotización personalizada primero</p>
                  <p>• Prefieres coordinar por teléfono</p>
                </div>
                <div className="space-y-2">
                  <p>• Quieres consultar con tu familia</p>
                  <p>• Necesitas programar para más adelante</p>
                  <p>• Tienes dudas sobre el proceso</p>
                </div>
              </div>
              <div className="mt-6 p-4 bg-red-50 rounded-lg">
                <p className="text-red-800 font-medium">
                  ¡No hay problema! Estamos aquí para ayudarte cuando estés listo.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;